export const blogs = [
  {
    id: 'android-hardware-part1-architecture',
    title: 'Android Hardware Integration: Part 1 - Platform Architecture',
    subtitle: 'Understanding the layered security model that governs all hardware access',
    excerpt: 'In Android, applications never directly access hardware. Every hardware interaction traverses a well-defined stack of platform layers. This article explains why this architecture exists and how each layer contributes to security and portability.',
    date: 'December 2025',
    readTime: '5 min read',
    tags: ['Android', 'Architecture', 'Security', 'Platform'],
    author: 'VC4U Engineering',
    featured: true,
    series: 'Android Hardware Integration',
    partNumber: 1
  },
  {
    id: 'android-hardware-part2-app-framework',
    title: 'Android Hardware Integration: Part 2 - Application & Framework Layers',
    subtitle: 'Building the Kotlin app and Java Framework API for hardware control',
    excerpt: 'Learn how to build an Android application that controls hardware through the Framework API. This article covers the Kotlin application code, the Framework Service Manager, and the Binder IPC mechanism.',
    date: 'December 2025',
    readTime: '8 min read',
    tags: ['Kotlin', 'Java', 'Binder IPC', 'Framework API'],
    author: 'VC4U Engineering',
    featured: false,
    series: 'Android Hardware Integration',
    partNumber: 2
  },
  {
    id: 'android-hardware-part3-system-service',
    title: 'Android Hardware Integration: Part 3 - System Service Implementation',
    subtitle: 'Building a System Service that bridges apps and HAL',
    excerpt: 'System Services run inside system_server with elevated privileges. This article shows how to create a System Service that receives requests from apps and forwards them to the HAL layer.',
    date: 'December 2025',
    readTime: '7 min read',
    tags: ['Java', 'System Service', 'system_server', 'AIDL'],
    author: 'VC4U Engineering',
    featured: false,
    series: 'Android Hardware Integration',
    partNumber: 3
  },
  {
    id: 'android-hardware-part4-hal-implementation',
    title: 'Android Hardware Integration: Part 4 - HAL Service Implementation',
    subtitle: 'Building the C++ HAL service that controls GPIO hardware',
    excerpt: 'The HAL (Hardware Abstraction Layer) is where Android meets physical hardware. This article covers AIDL interface definition, C++ implementation, and Linux sysfs GPIO access on Raspberry Pi 5.',
    date: 'December 2025',
    readTime: '10 min read',
    tags: ['C++', 'HAL', 'AIDL', 'GPIO', 'Raspberry Pi 5'],
    author: 'VC4U Engineering',
    featured: false,
    series: 'Android Hardware Integration',
    partNumber: 4
  },
  {
    id: 'android-hardware-part5-selinux-init',
    title: 'Android Hardware Integration: Part 5 - SELinux & Init Configuration',
    subtitle: 'Configuring security policies and service startup for your HAL',
    excerpt: 'Without correct SELinux policy, your HAL cannot access hardware. This article covers init scripts, SELinux policy creation, file contexts, and the complete request/response flow through all layers.',
    date: 'December 2025',
    readTime: '8 min read',
    tags: ['SELinux', 'Init', 'Security', 'Configuration'],
    author: 'VC4U Engineering',
    featured: false,
    series: 'Android Hardware Integration',
    partNumber: 5
  },
  {
    id: 'android-hardware-part6-automotive-vhal',
    title: 'Android Hardware Integration: Part 6 - Automotive VHAL',
    subtitle: 'Extending Android Automotive with custom Vehicle HAL properties',
    excerpt: 'Android Automotive uses the Vehicle HAL (VHAL) with a property-based model. This article shows how to extend VHAL to control physical hardware like hazard lights using GPIO.',
    date: 'December 2025',
    readTime: '10 min read',
    tags: ['Android Automotive', 'VHAL', 'CarPropertyManager', 'Vehicle Properties'],
    author: 'VC4U Engineering',
    featured: false,
    series: 'Android Hardware Integration',
    partNumber: 6
  }
];

export const getBlogById = (id) => {
  return blogs.find(blog => blog.id === id);
};

export const getBlogsBySeries = (seriesName) => {
  return blogs.filter(blog => blog.series === seriesName).sort((a, b) => a.partNumber - b.partNumber);
};
